import React, { useEffect, useState } from "react";
import "./style.css";
import {  VscClose } from "react-icons/vsc";
import { IoIosMenu } from "react-icons/io";import { Link } from "react-router-dom";
import { logotext ,socialprofils } from "../content_option";
import Themetoggle from "../components/themetoggle";
import { FaRegCopyright } from "react-icons/fa";

const Headermain = () => {
  const [isActive, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
    document.body.classList.toggle("ovhidden");
  };

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    let timeout;
    const handleScroll = () => {
      // Clear previous timeout
      clearTimeout(timeout);
      // Debounce scroll event - only update state if user stops scrolling
      timeout = setTimeout(() => {
        setIsScrolled(window.scrollY > 1);
      }, 150);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <header className={`site__header ${!isScrolled ? 'fixed-top' : ''}`}>
        <div className="d-flex align-items-center justify-content-between" >
          <Link  className="navbar-brand nav_ac" to="/">
            {logotext}
          </Link>
          <div className="d-flex align-items-center">
          <Themetoggle />
          <button className="menu__button  nav_ac" onClick={handleToggle}>
            {!isActive ? <VscClose /> : <IoIosMenu />}
          </button>
          
          </div>
        </div>

        <div className={`site__navigation ${!isActive ? "menu__opend" : ""}`}>
          <div className="bg__menu h-100">
            <div className="menu__wrapper">
              <div className="menu__container p-3">
                <ul className="the_menu">
                  <li className="menu_item ">
                  <Link  onClick={handleToggle} to="/" className="my-3">Home</Link>
                  </li>
                  <li className="menu_item">
                    <Link  onClick={handleToggle} to="/art_gallery" className="my-3"> Art Gallery </Link>
                  </li>
                  <li className="menu_item">
                  <Link onClick={handleToggle} to="/poetry" className="my-3"> Poetry</Link>
                  </li>
                  <li className="menu_item">
                  <Link onClick={handleToggle} to="/blog" className="my-3"> Blog</Link>
                  </li>
                  <li className="menu_item">
                  <Link onClick={handleToggle} to="/portfolio" className="my-3">Works</Link>
                  </li>
                  <li className="menu_item">
                  <Link onClick={handleToggle} to="/about" className="my-3">About</Link>
                  </li>
                  <li className="menu_item">
                  <Link onClick={handleToggle} to="/contact" className="my-3">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="menu_footer d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
            <div className="d-flex">
            <a href={socialprofils.facebook}>Facebook</a>
            <a href={socialprofils.github}>Github</a>
            <a href={socialprofils.twitter}>Twitter</a>
            </div>
            <p className="copyright m-0">
              <FaRegCopyright /> know_one08
            </p>
          </div>
        </div>
      </header>
      <div className="br-top"></div>
      <div className="br-bottom"></div>
      <div className="br-left"></div>
      <div className="br-right"></div>
      
    </>
  );
};

export default Headermain;


